/** Format a Stripe minor-unit amount + ISO currency as a localized string. */
export function formatMoney(minor: number, currency: string): string {
  const major = minor / 100;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(major);
  } catch {
    return `$${major.toFixed(2)}`;
  }
}

/** Format a price for display: "$10.00/month", "$50.00/once". */
export function formatPrice(
  amountMinor: number,
  currency: string,
  interval: string | null,
  intervalCount = 1
): string {
  const money = formatMoney(amountMinor, currency);
  if (!interval) return `${money} (one-time)`;
  const period = intervalCount > 1 ? `${intervalCount} ${interval}s` : interval;
  return `${money}/${period}`;
}

/** Format a Unix-seconds timestamp as a localized short date (e.g. "Jan 5, 2026"). */
export function formatDate(unixSeconds: number): string {
  try {
    return new Intl.DateTimeFormat('en-US', {
      dateStyle: 'medium',
    }).format(new Date(unixSeconds * 1000));
  } catch {
    return new Date(unixSeconds * 1000).toISOString().slice(0, 10);
  }
}
